let actions = {
  async custom({dispatch}, message = '') {
    dispatch('popups/show/success',{
      message: `${message} successfully.`,
    }, {root: true})
  },
  async updating({dispatch}, message = '') {
    dispatch('popups/show/success',{
      message: `${message ? `${message} successfully` : 'Successfully'} updated.`,
    }, {root: true})
  },
  async uploading({dispatch}, message = '') {
    dispatch('popups/show/success',{
      message: `${message ? `${message} successfully` : 'Successfully'} uploaded.`,
    }, {root: true})
  },
  async creating({dispatch}, message = '') {
    dispatch('popups/show/success',{
      message: `${message ? `${message} successfully` : 'Successfully'} created.`,
    }, {root: true})
  },
  async deleting({dispatch}, message = '') {
    dispatch('popups/show/success',{
      message: `${message ? `${message} successfully` : 'Successfully'} deleted.`,
    }, {root: true})
  },
  async removing({dispatch}, message = '') {
    dispatch('popups/show/success',{
      message: `${message ? `${message} successfully` : 'Successfully'} removed.`,
    }, {root: true})
  },

  async uploadingImage({dispatch}) {
    dispatch('popups/show/success',{
      message: 'Your image was successfully updated.'
    }, {root: true})
  },
}

export default {
  namespaced: true,
  actions
};
